"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var store_1 = require("../store/store");
exports.default = satcheljs_1.mutatorAction('setSupportedTimeZones', function setSupportedTimeZones(supportedTimeZones) {
    var regionalOptions = store_1.default();
    regionalOptions.supportedTimeZones = supportedTimeZones;
});
//# sourceMappingURL=setSupportedTimeZones.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/mutators/setSupportedTimeZones.js
// module id = 4924
// module chunks = 2